import Articals from '../KnowledgeBase/Articals';
import HeaderPart from '../KnowledgeBase/HeaderPart';
import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import CategoryData from './CategoryData';

const KnowledgeCategoryContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Knowledgebase' parent='Knowledgebase' title='Knowledgebase Category' />
      <Row>
        <HeaderPart />
        <Articals />
        <CategoryData />
      </Row>
    </Container>
  );
};
export default KnowledgeCategoryContain;
